import { Component, EventEmitter, Input, Output } from '@angular/core';
import { fade } from '@zipari/design-system';
import { ConfirmationModalConfig } from '@zipari/shared-sbp-models';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  animations: [fade],
})
export class ConfirmationModalComponent {
  public open: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  @Input() config: ConfirmationModalConfig = <ConfirmationModalConfig>{};
  @Input() context = <any>{};
  @Output() cancel = new EventEmitter();
  @Output() confirm = new EventEmitter();
}
